import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import { Events } from '../../utils/dom/html-events';
import SuggestionInput from '../SuggestionInput';
import FormComponent from '../FormComponent';
import { InputTypes, validFormElementValue } from '../../utils/validateFormElement';

class SearchInputField extends FormComponent {
	constructor(element, config) {
		super(element, config, false);
		this.dataMapping = {};
		this.filterDataMapping = {};
	}
	markup(value, rowData, titleMarkup) {
		this.searchInputFieldContainerClass = `lta-search-input-field-container-${rowData.id}`;
		const inputID = `lta-search-input-field-id-${rowData.id}`;
		const searchInputInstructionLabel = this.renderInstructionLabel(rowData?.instructionText, inputID);
		const inputName = `lta-search-input-field-name-${rowData.id}`;
		const placeholderText = rowData.placeHolder ? rowData.placeHolder : '';
		const inputValue = rowData?.value && typeof rowData?.value === 'string' ? rowData?.value : '';
		const labelData = rowData?.label
			? `<label for=${inputID} class="lta-text-input__label u-text-grey-lta">${rowData?.label}</label>`
			: '';
		const labelElement = rowData?.titlePattern ? '' : labelData;

		return `<div class="lta-autosuggest-input lta-search-input-field u-mb-5" data-endpoint="${rowData.apiEndpoint}" data-endpointkey="${rowData?.paramName}" data-result-key="${rowData.apiResponseKey}" data-filter-previous="false">
					<div id="autosuggest-input" role="combobox" aria-haspopup="listbox" aria-owns="auto-input" aria-expanded="false">
						<div class="lta-search-input-field-title">${titleMarkup}</div>
						<div class="lta-text-input__wrapper ${this.searchInputFieldContainerClass}">
							${labelElement}
							${searchInputInstructionLabel}
							<div class="lta-text-input--error"></div>
							<div class="lta-text-input__icon-btn-wrapper">
								<div class="lta-text-input-pre-icon">
									<svg class="lta-icon js-lta-text-input--btn-icon" width="1em" height="1em" fill="currentColor" alt="search" aria-hidden="true">
									<use xlink:href="/static/images/icons/lta-icons.svg#search"></use>
									</svg>
								</div>
								<input 
									type="text"
									class="lta-text-input" 
									id="${inputID}"
									name="${inputName}" 
									aria-label="${rowData.label}"
									placeholder="${placeholderText}"
									value="${inputValue}"
									autocomplete="off" 
									aria-autocomplete="list" 
									aria-control="res" 
									aria-activedescendant="seggestion-1"
								/>
								<button type="button" class="lta-btn js-lta-text-input--close hide-btn" aria-label="close">
									<svg class="lta-icon js-lta-text-input--btn-icon" width="1em" height="1em" fill="currentColor" alt="close" aria-hidden="true">
									<use xlink:href="/static/images/icons/lta-icons.svg#close"></use>
									</svg>
								</button>
							</div>
						</div>
					</div>
					<div class="lta-results-wrapper u-bg-white" role="status">
						<p class="lta-instruction u-label2 u-pt-1 u-pb-1 u-pl-3 u-bg-background-grey is-search-label">Keep typing to see more results</p>
						<p class="lta-instruction u-label2 u-pt-1 u-pb-1 u-pl-3 u-bg-background-grey is-no-results-label">No results found</p>
						<div id="results" class="lta-suggest-results u-bg-white u-body1">
							<ul id="res" role="listbox"></ul>
						</div>
					</div>
				</div>`;
	}
	afterRender() {
		this.suggestionInputContainers = SelectorEngine.findOne('.lta-autosuggest-input', this.containerEl);
		this.suggestionInputSearch = SelectorEngine.findOne(`.${this.searchInputFieldContainerClass}`, this.containerEl);
		this.suggestionInputElement = SelectorEngine.findOne('input', this.suggestionInputSearch);

		this.suggestionInputComp = SuggestionInput.getOrCreateInstance(this.suggestionInputContainers, { additionalParams: this?.data?.additionalParams });
		this.suggestionInputComp.state.eventName = this.data.dataEventName;
		this.suggestionInputComp.state.dataKey = this.data.dataKey;
		if (this.data.hasOwnProperty('keepTypingLength')) {
			this.suggestionInputComp.state.keepTypingLength = this.data?.keepTypingLength;
		}
		if (this.data.hasOwnProperty('minSearchChar')) {
			this.suggestionInputComp.state.inputLength = this.data?.minSearchChar;
		}

		EventHandler.on(this.suggestionInputElement, Events.Blur, () => {
			setTimeout(() => {
				this.validate(true);
			}, 200);
		});
		EventHandler.on(this.suggestionInputElement, Events.Keyup, () => {
			this.validate();
		});
		EventHandler.on(this.suggestionInputContainers, this.data.dataEventName, (event) => {
			this.suggestionInputElement.value = (this.data.valueKey ? event.detail[this.data.valueKey] : event.detail) || '';
			this.value = {
				...this.data,
				value: event.detail
			};
			if (this.value) {
				this.dependentQuestion = this.value.dependentQuestion;
			}
			this.validate(true);
		});
		EventHandler.on(this.suggestionInputElement, Events.Change, () => {
			const inputValue = this.getValueFromElement();
			this.value = {
				...this.data,
				value: inputValue
			};
		});
		this.setupValidateObject();
	}
	searchInputMappingChange() {
		this.suggestionInputComp.state.dataMapping = this.dataMapping;
		this.suggestionInputComp.state.filterDataMapping = this.filterDataMapping;
	}
	renderInstructionLabel(instructionLabel, inputID) {
		return instructionLabel
			? `<label for=${inputID} class="lta-text-input__label u-text-grey-lta">
										<span class="lta-text-input__label-instruction">${instructionLabel}</span>
									</label>`
			: '';
	}
	setupValidateObject() {
		this.formElementData = {
			element: this.suggestionInputSearch,
			formElement: this.suggestionInputElement,
			errorMessage: this.data.errorMessage,
			inputType: InputTypes.SELECTOR_INPUT,
			hasIcon: false
		};
	}

	validate(shouldValidate = false) {
		const inputValue = this.getValueFromElement();
		if (this.suggestionInputComp.state.isSelected) {
			const data = {
				...this.formElementData,
				value: inputValue
			};
			return validFormElementValue(this.getValueFromElement(true, data), data);
		}
		const initialValueNotChanged = !!this.data?.value && this.data?.value === inputValue 
		return !!shouldValidate
			?  initialValueNotChanged || validFormElementValue(this.getValueFromElement(true, this.formElementData), this.formElementData)
			: false;
	}
}
export default SearchInputField;
